import { t } from 'i18next'
import { useRef, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { calendarImportSeveraWorkhours } from '../../api'
import { Button } from '../../common/Button.tsx'
import DefaultDatePicker from '../../common/datepicker/DefaultDatePicker.jsx'
import { LoadingButton } from '../../common/loaders/loadingbutton'
import { localDate } from '../../common/utils'

export function WorkhoursModal({ closeModal }) {
	const formRef = useRef(null)
	const [importing, setImporting] = useState(false)
	const prefix = 'workhoursImport'

	const lastMonth = new Date()
	lastMonth.setDate(0) // last day of last month
	const lastDayOfMonth = localDate(lastMonth)

	const { control, watch, handleSubmit } = useForm({
		defaultValues: {
			start: `${lastDayOfMonth.slice(0, -2)}01`,
			end: lastDayOfMonth,
		},
	})

	const formValues = watch()

	const onSubmit = async (data) => {
		setImporting(true)
		await calendarImportSeveraWorkhours(data)
		setImporting(false)
		closeModal(true) // reloadData
	}

	return (
		<Modal show onHide={closeModal}>
			<Modal.Header closeButton>
				<Modal.Title>Import Workhours</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
					<Row>
						<Form.Group as={Col} controlId="start">
							<DefaultDatePicker id={`${prefix}-start`} name="start" label={t('Starts', 'Alkaa')} control={control} />
						</Form.Group>

						<Form.Group as={Col} controlId="end">
							<DefaultDatePicker id={`${prefix}-end`} name="end" label={t('Ends', 'Päättyy')} control={control} />
						</Form.Group>
					</Row>
				</Form>
			</Modal.Body>

			<Modal.Footer style={{ justifyContent: 'space-between' }}>
				<Button testId="cancel" variant="outline-primary" onClick={closeModal}>
					{t('Cancel', 'Peruuta')}
				</Button>
				<Button
					testId="import"
					disabled={!(formValues.start && formValues.end)}
					variant="primary"
					onClick={() => formRef.current.requestSubmit()}
				>
					{importing && <LoadingButton />} &nbsp;
					{t('Import', 'Tuo')}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
